import Button from '@doordash/component-button'
import { Colors, Media, Spacing } from '@doordash/design-language'
import styled from 'styled-components'

export const ButtonContainer = styled.div`
  display: none;
  ${Media.Mobile`
    display: block;
    position: fixed;
    width: 100vw;
    padding: ${Spacing.Medium}px;
    bottom: 0;
    background: ${Colors.SystemWhite};
    border-top: 1px solid ${Colors.SystemGrey5};
    z-index: 5;
  `}
`

export const GetStartedButton = styled(Button).attrs<{}>({
  type: Button.Types.PrimaryPill,
})``
